const profileFields = ['name', 'real_name', 'bank_name', 'bank_account', 'receive_phone', 'idcard_num'];

export function profileFormValues(info, masked) {
  const values = {};
  profileFields.forEach((field) => {
    const value = info[field] == null ? '' : String(info[field]);
    if (!masked || field === 'name' || !value) {
      values[field] = value;
    } else if (field === 'receive_phone' && value.length > 7) {
      values[field] = value.slice(0, 3) + '****' + value.slice(-4);
    } else if ((field === 'bank_account' || field === 'idcard_num') && value.length > 4) {
      values[field] = '********' + value.slice(-4);
    } else {
      values[field] = value.length > 1 ? value.slice(0, 1) + '***' : '*';
    }
  });
  return values;
}
